import React, { useState } from "react";
import "../App.css";
import { Formik, Form, Field, useFormik } from "formik";
import { useNavigate, Link } from "react-router-dom";
import * as Yup from "yup";
import Logo from "../Assets/logo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import login from "../Api/login";
import Swal from "sweetalert2";
import Copyright_Footer from "../Components/copyrightFooter";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const initialValues = {
    username: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().min(3).required("Please enter your username"),
    password: Yup.string()
      .min(4)
      .max(12)
      .required("Please enter your password"),
  });

  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      try {
        await login(values);
        navigate("/home");
        Toast.fire({
          icon: 'success',
          title: 'Successfully Login'
        })
      } catch (error) {
        Toast.fire({
          icon: 'error',
          title: error.message
        })
      }
    },
  });

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <div className="container mobile-page">
      <div className="row d-flex justify-content-center align-items-center flex-column" id="login-page">

        <img src={Logo} alt="Logo" className='logo mb-5'/>

        <div className="mt-5 col-12 col-xl-12 col-md-10 col-sm-10 text-center text-white">
          <h2 className="fw-bold">Hi! Welcome</h2>
          <span>Sign with Username or email and password to use your account</span>
        </div>

        <div className="mt-5 col-12 col-xl-12 col-md-10 col-sm-10">
          <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
          >
            <Form onSubmit={formik.handleSubmit}>
              <div className="rounded-4 py-1 px-4 my-2 d-flex flex-nowrap align-items-center light-black">
                <span className='text-pink'>Username</span>
                <Field
                    id="username"
                    name="username"
                    type="text"
                    placeholder="Type Here"
                    className="light-black text-white"
                    {...formik.getFieldProps('username')}
                />

              </div>
              {formik.touched.username && formik.errors.username && (
                  <div className='mt-1 text-center'>
                    <span className='error'>{formik.errors.username}</span>
                  </div>
              )}

              <div className="rounded-4 py-1 px-4 my-2 d-flex flex-nowrap align-items-center light-black">
                <span className='text-pink'>Password</span>
                <Field
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Type Here"
                    className="light-black text-white"
                    {...formik.getFieldProps('password')}
                />
                <span
                    className="toggle-password"
                    onClick={togglePasswordVisibility}
                >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </span>


              </div>
              {formik.touched.password && formik.errors.password && (
                  <div className='mt-1 text-center'>
                    <span className='error'>{formik.errors.password}</span>`
                  </div>
              )}

              <div className="col-12 d-flex flex-row justify-content-between mt-5">
                <button className="px-4 py-3 rounded-4 mx-1 deepBlack text-white">
                  <Link className="text-white text-decoration-none" to="/register">Create Account</Link>
                </button>
                <button type="submit" className="px-4 py-3 rounded-4 mx-1 pink text-white" disabled={!formik.isValid}>Sign In</button>
              </div>
            </Form>
          </Formik>
        </div>

      </div>
      <Copyright_Footer/>
    </div >
  );
}
